import { useCallback, useMemo } from "react";

import { stringToBoolean } from "@/lib/chillnn/string-to-boolean";

import type { ForNodeType } from "@/components/features/_model/types";
import type { SiteControllerSettingBeds24FormModel } from "@/components/features/settings/site-controller/model/beds24/type";
import type { SiteControllerSettingBeds24FormModelMethodsType } from "@/components/features/settings/site-controller/model/beds24/use-case/use-create-model/methods";

import type { FormOptionType } from "@/components/ui/form/_types/type";

type Props = {
	setUpRoomPriceByChillnn: SiteControllerSettingBeds24FormModel["ViewModel"]["setUpRoomPriceByChillnn"]; //
	onSetSetUpRoomPriceByChillnn: SiteControllerSettingBeds24FormModelMethodsType["siteControllerSettingBeds24FormModelMethods"]["onSetSetUpRoomPriceByChillnn"];
};

export const useBeds24SetUpRoomPriceByChillnn = ({
	setUpRoomPriceByChillnn,
	onSetSetUpRoomPriceByChillnn: _onSetSetUpRoomPriceByChillnn,
}: Props) => {
	const setUpRoomPriceByChillnnForRadioGroup: ForNodeType<string> = useMemo(() => {
		return {
			isEdited: setUpRoomPriceByChillnn?.isEdited ?? false,
			error: setUpRoomPriceByChillnn?.error,
			value: String(setUpRoomPriceByChillnn?.value ?? false),
		};
	}, [setUpRoomPriceByChillnn?.error, setUpRoomPriceByChillnn?.isEdited, setUpRoomPriceByChillnn?.value]);

	const setUpRoomPriceByChillnnOptions: FormOptionType[] = [
		{
			id: "setUpRoomPriceByChillnnOptions_0",
			label: "CHILLNNで料金管理する",
			value: "true",
		},
		{
			id: "setUpRoomPriceByChillnnOptions_1",
			label: "Beds24で料金管理する",
			value: "false",
		},
	];

	const onSetSetUpRoomPriceByChillnn = useCallback(
		(value: string) => {
			_onSetSetUpRoomPriceByChillnn(stringToBoolean(value));
		},
		[_onSetSetUpRoomPriceByChillnn],
	);

	return {
		setUpRoomPriceByChillnnForRadioGroup,
		onSetSetUpRoomPriceByChillnn,
		setUpRoomPriceByChillnnOptions,
	};
};
